import React from 'react';
import moment from 'moment';
// material
import Dialog from 'material-ui/Dialog';
import IconButton from 'material-ui/IconButton';
import CloseIcon from 'material-ui/svg-icons/navigation/close';
// style
import './last-edit.css';

// momentjs
import { modalStyle } from '../media/modal-style';

require('moment/locale/ru');

class LastEdit extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            history: props.changes,
            showHistoryList: false,
            open: false,
            isDialog: props.changes.length > 10,
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            history: nextProps.changes,
            isDialog: nextProps.changes.length > 10,
        });
    }

    onClick = () => {
        if (this.state.isDialog) {
            this.setState({ open: true });
        } else {
            this.setState({ showHistoryList: !this.state.showHistoryList });
        }
    };

    convertList = arr => arr.map((item) => {
        return {
            date: moment(new Date(item.modDate)).format('DD MMMM YYYY, HH:mm'),
            name: item.userName,
        };
    });

    showLastEdit = (date, name, count) => (
        <div>
            <small className="last-edit--title js-last-edit-title">Дата последнего изменения</small>
            <div className="last-edit--info">
                {date} - {name}
            </div>
            {count > 1 &&
            <a
                onClick={this.onClick}
                className="last-edit--link js-last-edit-more"
            >
                Посмотреть все изменения (всего {count})
            </a>
            }
        </div>
    );

    showHistory = (history, isDialog) => {
        const list = this.convertList(history);
        const itemClass = isDialog ? 'last-edit--info last-edit--info_solid' : 'last-edit--info';
        return (
            <div>
                {!isDialog && <small className="last-edit--title js-last-edit-title">История изменений</small>}
                {
                    list.map((item, index) => {
                        return (
                            <div
                                key={index}
                                className={itemClass}
                            >
                                {item.date} - {item.name}
                            </div>
                        );
                    })
                }
                {!isDialog && <a onClick={this.onClick} className="last-edit--link js-last-edit-more">Убрать</a>}
            </div>
        );
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    render() {
        const { history } = this.state;
        if (!history.length) {
            return <div />;
        }
        const count = history.length;
        const lastEditPerson = history[count - 1];
        const { date, name } = this.convertList([lastEditPerson])[0];
        return (
            <section className="last-edit">
                {!this.state.showHistoryList && this.showLastEdit(date, name, count)}
                {!this.state.isDialog && this.state.showHistoryList && this.showHistory(history)}
                <Dialog
                    open={this.state.open}
                    modal={false}
                    title="История изменений"
                    contentStyle={{
                        ...modalStyle.main,
                        width: 585,
                        maxWidth: 594,
                    }}
                    bodyStyle={{
                        ...modalStyle.body,
                        borderTop: 'none',
                        borderBottom: 'none',
                        padding: '9px 31px 30px',
                    }}
                    titleStyle={{
                        padding: '24px 24px 20px 30px',
                        fontSize: 24,
                    }}
                    overlayStyle={modalStyle.overlay}
                    onRequestClose={this.handleClose}
                    autoScrollBodyContent={true}
                >
                    <div style={{
                        position: 'absolute',
                        right: 8,
                        top: 9,
                    }}>
                        <IconButton onClick={this.handleClose}>
                            <CloseIcon hoverColor="#542376" />
                        </IconButton>
                    </div>
                    {this.showHistory(history, true)}
                </Dialog>
            </section>
        );
    }
}

export default LastEdit;



// WEBPACK FOOTER //
// src/components/lastEdit/LastEdit.js